import React, { useState, useEffect, useContext } from 'react';
import LeadershipStyleImg from "../../../../Assets/Images/LeadershipStyle.png";
import PolarAreaChart from "../../../PolarAreaChart/PolarAreaChart";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import GroupReportContext from '../../../../Context/GroupReportContext';

export default function LeadershipStyleFirst360({ apiData, reportType, pageNumber }) {
  // console.log("apiData", apiData);
  const { updateLeaderchartdata, updateLeaderselfchartdata } = useGroupReportDate();
  const { averagePercentagesLeadership, averagePercentagesLeadershipSelf } = useContext(GroupReportContext)
  const [leadershipSnapshotResults, setLeadershipSnapshotResults] = useState([]);
  const [leadershipSnapshotResults360, setLeadershipSnapshotResults360] = useState([]);
  const [variablsMapArray, setVariableMapArray] = useState();
  const [leadershipLabels, setLeadershipLabels] = useState([]);
  const [highestLeadership, setHighestLeadership] = useState("");
  const [aggregated360Results, setAggregated360Results] = useState([]);
  const [aggregated360Labels, setAggregated360Labels] = useState([]);
  const [aggregated360Highest, setAggregated360Highest] = useState("");

  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" },
  ];
  
  // console.log("averagePercentagesLeadership,leadership360ChartData",averagePercentagesLeadership,leadership360ChartData)

  useEffect(() => {
    const variableMap = apiData?.variables?.reduce((acc, el) => {
      acc[el.variable] = el.score;
      return acc;
    }, {});

    // console.log("variableMap", variableMap);
    setVariableMapArray(variableMap);
  }, [apiData]);

  // Calculate self data for leadership styles - using exact same logic as LeadershipChart.jsx
  useEffect(() => {
    if (apiData?.variables) {
      // console.log("apiData.variables", apiData.variables);

      // Create variable map exactly like LeadershipChart.jsx
      const variableMap = apiData.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {}) || {};

      if (Object.keys(variableMap).length === 0) return;

      // Use exact same variable names as LeadershipChart.jsx
      const performance_r1_m = variableMap["per_round1_m"] || 0;
      const strategic_r1_m = variableMap["strat_round1_m"] || 0;
      const visionary_r1_m = variableMap["vis_round1_m"] || 0;
      const collaborative_r1_m = variableMap["col_round1_m"] || 0;

      const performance_r2_m = variableMap["per_round2_m"] || 0;
      const strategic_r2_m = variableMap["strat_round2_m"] || 0;
      const visionary_r2_m = variableMap["vis_round2_m"] || 0;
      const collaborative_r2_m = variableMap["col_round2_m"] || 0;

      const performance_r1_l = variableMap["per_round1_l"] || 0;
      const strategic_r1_l = variableMap["strat_round1_l"] || 0;
      const visionary_r1_l = variableMap["vis_round1_l"] || 0;
      const collaborative_r1_l = variableMap["col_round1_l"] || 0;

      const performance_r2_l = variableMap["per_round2_l"] || 0;
      const strategic_r2_l = variableMap["strat_round2_l"] || 0;
      const visionary_r2_l = variableMap["vis_round2_l"] || 0;
      const collaborative_r2_l = variableMap["col_round2_l"] || 0;

      // Use exact same calculation logic as LeadershipChart.jsx
      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m);
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2;
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l);
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2;

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];

      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      // Use exact same order as LeadershipChart.jsx
      const results = [
        getPercentageOrder("strategic"),
        getPercentageOrder("visionary"),
        getPercentageOrder("performance"),
        getPercentageOrder("collaborative"),
      ];

      // Use exact same labels order as LeadershipChart.jsx
      const labelsArray = ["strategic", "visionary", "performance", "collaborative"];

      // console.log("Self calculation results:", results);
      // console.log("Self calculation labels:", labelsArray);
      // console.log("Highest leadership style:", most_label);

      setHighestLeadership(most_label);
      setLeadershipSnapshotResults(results);
      setLeadershipLabels(labelsArray);
    }
  }, [apiData]);

  // Save leadershipSnapshotResults to leaderselfchartdata
  useEffect(() => {

    const leadershipSelfChartData = [
      {
        "avg": averagePercentagesLeadershipSelf?.find((el) => el.name == "Performance").avg,
        "name": "Performance"
      },
      {
        "avg": averagePercentagesLeadershipSelf?.find((el) => el.name == "Collaborative").avg,
        "name": "Collaborative"
      },
      {
        "avg": averagePercentagesLeadershipSelf?.find((el) => el.name == "Visionary").avg,
        "name": "Visionary"
      },
      {
        "avg": averagePercentagesLeadershipSelf?.find((el) => el.name == "Strategic").avg,
        "name": "Strategic"
      }
    ]

    if (leadershipSelfChartData.length > 0) {
      const scoresOnly = leadershipSelfChartData?.map(value => parseFloat(value?.avg?.toFixed(2)) || 0);
      updateLeaderselfchartdata(scoresOnly);
    }
  }, [averagePercentagesLeadershipSelf]);


  // console.log("leadershipSnapshotResults",leadershipSnapshotResults)

  // Calculate 360 aggregated data for leadership styles
  const calculate360AggregatedData = () => {
    if (!apiData?.memberResults?.allMembersData) {
      return;
    }

    const allMembersData = apiData.memberResults.allMembersData;
    const memberResults = [];

    Object.values(allMembersData).forEach(memberAssessment => {
      if (!memberAssessment?.variables) return;

      // Use exact same logic as LeadershipChart.jsx for each member
      const variableMap = memberAssessment.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {}) || {};

      if (Object.keys(variableMap).length === 0) return;

      // Use exact same variable names as LeadershipChart.jsx
      const performance_r1_m = variableMap["per_round1_m"] || 0;
      const strategic_r1_m = variableMap["strat_round1_m"] || 0;
      const visionary_r1_m = variableMap["vis_round1_m"] || 0;
      const collaborative_r1_m = variableMap["col_round1_m"] || 0;

      const performance_r2_m = variableMap["per_round2_m"] || 0;
      const strategic_r2_m = variableMap["strat_round2_m"] || 0;
      const visionary_r2_m = variableMap["vis_round2_m"] || 0;
      const collaborative_r2_m = variableMap["col_round2_m"] || 0;

      const performance_r1_l = variableMap["per_round1_l"] || 0;
      const strategic_r1_l = variableMap["strat_round1_l"] || 0;
      const visionary_r1_l = variableMap["vis_round1_l"] || 0;
      const collaborative_r1_l = variableMap["col_round1_l"] || 0;

      const performance_r2_l = variableMap["per_round2_l"] || 0;
      const strategic_r2_l = variableMap["strat_round2_l"] || 0;
      const visionary_r2_l = variableMap["vis_round2_l"] || 0;
      const collaborative_r2_l = variableMap["col_round2_l"] || 0;

      // Use exact same calculation logic as LeadershipChart.jsx
      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m);
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2;
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l);
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2;

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];

      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      // Use exact same order as LeadershipChart.jsx
      const results = [
        getPercentageOrder("strategic"),
        getPercentageOrder("visionary"),
        getPercentageOrder("performance"),
        getPercentageOrder("collaborative"),
      ];

      memberResults.push({
        results,
        most_label,
        memberName: memberAssessment.userName,
        designation: memberAssessment.designation
      });
    });

    if (memberResults.length > 0) {
      // Calculate average results across all members
      const averageResults = memberResults.reduce((acc, curr) => {
        curr.results.forEach((score, index) => {
          if (!acc[index]) acc[index] = 0;
          acc[index] += score;
        });
        return acc;
      }, []).map(total => total / memberResults.length);

      // Find most common highest leadership style
      const mostCommonLabel = memberResults.reduce((acc, curr) => {
        acc[curr.most_label] = (acc[curr.most_label] || 0) + 1;
        return acc;
      }, {});

      const overallHighest = Object.entries(mostCommonLabel).reduce((max, [key, count]) =>
        count > max.count ? { name: key, count } : max,
        { name: "", count: -Infinity }
      ).name;

      // console.log("360 Average Results:", averageResults);
      // console.log("360 Overall Highest:", overallHighest);

      setAggregated360Results(averageResults);
      // Same labels order as LeadershipChart.jsx
      setAggregated360Labels(["strategic", "visionary", "performance", "collaborative"]);
      setAggregated360Highest(overallHighest);
    }
  };

  // Save aggregated360Results to leaderchartdata
  useEffect(() => {

    const leadership360ChartDataPayload = [
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Performance").avg,
        "name": "Performance"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Collaborative").avg,
        "name": "Collaborative"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Visionary").avg,
        "name": "Visionary"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Strategic").avg,
        "name": "Strategic"
      }
    ]

    const leadership360ChartData = [
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Strategic").avg,
        "name": "Strategic"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Visionary").avg,
        "name": "Visionary"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Performance").avg,
        "name": "Performance"
      },
      {
        "avg": averagePercentagesLeadership?.find((el) => el.name == "Collaborative").avg,
        "name": "Collaborative"
      }
    ]

    
    setLeadershipSnapshotResults360(leadership360ChartData)

    if (leadership360ChartDataPayload.length > 0) {
      const scoresOnly = leadership360ChartDataPayload?.map(value => parseFloat(value?.avg?.toFixed(2)) || 0);
      updateLeaderchartdata(scoresOnly);
    }
  }, [averagePercentagesLeadership]);

  useEffect(() => {
    if (apiData?.memberResults?.allMembersData) {
      calculate360AggregatedData();
    }
  }, [apiData?.memberResults]);

  const styles = {
    container: {
      padding: "16px 0px",
      fontFamily: "Helvetica, sans-serif",
    },
    title: {
      fontSize: "24px",
      lineHeight: "48px",
      color: "#426B88",
      fontWeight: "700",
      margin: 0
    },
    centerTitle: {
      fontSize: "24px",
      fontWeight: "700",
      color: "#426B88",
      textAlign: "center",
      lineHeight: "48px",
      margin: 0,
    },
    paragraph: {
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: 0,
      color: "#000",
      fontWeight: "400",
    },
    chartsContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "wrap",
    },
    chartWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    chartTitle: {
      fontWeight: "700",
      color: "#426B88",
      fontSize: "19px",
      lineHeight: "48px",
      letterSpacing: 0
    },
    chart: {
      width: "350px",
      height: "350px",
    },
    divider: {
      borderLeft: "1px solid #ccc",
      height: "390px",
    },
  };

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div style={styles.container}>
        <h3 style={{ fontSize: '14px', marginTop: 0, marginBottom: "16px", fontWeight: 700, fontFamily: "Helvetica, sans-serif", lineHeight: "15px", letterSpacing: "0px", color: '#00577D' }} >LEADERSHIP STYLE OVERVIEW CHART</h3>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', justifyContent: "space-between", }}>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <span style={{
              fontWeight: '700',
              marginBottom: '2px',
              color: '#00577D',
              fontSize: '10px',
              lineHeight: "14px",
              fontFamily: 'Helvetica'
            }}>SELF</span>
            <div>
              <PolarAreaChart
                originalData={leadershipSnapshotResults.map(value => parseFloat(value.toFixed(2)) || 0)}
                labels={leadershipLabels}
                ch="strategic"
                position="center"
              />
            </div>
          </div>
       <div style={{ borderLeft: '1px solid rgb(0,0,0)', height: '171px', alignSelf: 'center', marginTop: '18px' }} />

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <span style={{
              fontWeight: '700',
              marginBottom: '2px',
              color: '#00577D',
              fontSize: '10px',
              lineHeight: "14px",
              fontFamily: 'Helvetica'
            }}>360</span>
            <div>
              <PolarAreaChart
                originalData={leadershipSnapshotResults360?.map(value => parseFloat(value?.avg?.toFixed(2)) || 0)}
                labels={leadershipLabels}
                ch="strategic"
                position="center"
              />
            </div>
          </div>
        </div>

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <p style={{ margin: 0, fontWeight: "400", fontSize: "8px", lineHeight: '12px', color: '#00577D' }}>
            These charts reflect both your own results and the combined results calculated with all the observer scores (excluding yours). The highest result is your starter quadrant. We will reflect more on your flow into the other quadrants in the next section.
          </p>
        </div>

        <p style={{ margin: 0, fontWeight: "700", fontSize: "11px", lineHeight: '15px', color: '#00577D', padding: "32px 0px" }} >NOTES AND OBSERVATIONS:</p>

      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
